export default "__VITE_ASSET__c0642d84__"